import React from "react";

export default function InputFilter({
  value,
  placeholder,
  onChange,
  label,
  id
}) {
  return (
    <div className="grid-item" id={id}>
      <div className="dropdown-label">{label}</div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          paddingRight: "10px",
        }}
      >
        <input
          placeholder={placeholder}
          type="text"
          style={{ width: "17.8vw", color:"hsl(0, 0%, 20%)"}}
          className="custom-input-filters"
          value={value}
          onChange={onChange}
        />
      </div>
    </div>
  );
}
